<mat-icon [ngClass]="colorClass" [class.zef-icon-small]="size === 'small'">
  {{ kind }}
</mat-icon>

<label
  [ngClass]="size === 'small' ? colorClass : ''"
  [class.zef-text-p3]="size === 'small'"
  [class.zef-text-p1]="size === 'medium'"
  class="zef-text-overflow-line"
>
  @if (defaultLabel) {
    @switch (kind) {
      @case ('email') {
        <ng-container i18n>Email</ng-container>
      }
      @case ('sms') {
        <ng-container i18n>SMS</ng-container>
      }
      @case ('link') {
        <ng-container i18n>Link</ng-container>
      }
      @case ('embed') {
        <ng-container i18n>Embed</ng-container>
      }
      @case ('popup') {
        <ng-container i18n>Popup</ng-container>
      }
      @case ('poll') {
        <ng-container i18n>Live poll</ng-container>
      }
    }
  }

  @if (!defaultLabel) {
    <ng-content></ng-content>
  }
</label>
